import CheckEmailImage from 'src/assets/images/check_email.svg';
import logo from 'src/assets/icons/team_cap_icon.svg';

type EmailConfirmationProps = {
  children: React.ReactNode;
  cardContainerClassName?: string;
};

const EmailConfirmationWrapper = ({
  children,
  cardContainerClassName,
}: EmailConfirmationProps) => {
  return (
    <>
      <div className="text-center w-full h-screen overflow-hidden bg-cream flex align-middle justify-center items-center">
        <div>
          <div className="mb-12 flex justify-center">
            <img src={logo} alt="teamcap" className="h-7 w-10 mt-3.5 mr-2" />
            <div className=" h-8 text-blue-950 text-[34px] font-normal font-Gilroy">
              TeamCap
            </div>
          </div>
          <div
            className={`w-[540px] h-[503px] bg-white flex justify-center items-center flex-col gap-3 rounded-xl ${cardContainerClassName}`}
          >
            <img src={CheckEmailImage} alt="CheckEmail" className="mt-5 mb-6" />
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailConfirmationWrapper;
